import { type ForwardRefExoticComponent, type RefAttributes } from 'react';

import UntypedTextInput from './TextInput';

// The legacy `~/ui` TextInput is an untyped forwardRef wrapped in a HOC, so its
// inferred type drops all props. Re-typed here once so `.tsx` conversions can
// import this instead of re-declaring the same cast per file.
export interface TextInputProps {
  autoFocus?: boolean;
  disabled?: boolean;
  error?: string;
  flexGrow?: number;
  id?: string;
  name?: string;
  placeholder?: string;
  value?: string;
  width?: 's' | 'm' | 'l' | 'fullWidth';
  onChange: (value: string) => void;
  onEnter?: () => void;
  onBlur?: () => void;
}

export const TextInput =
  UntypedTextInput as unknown as ForwardRefExoticComponent<
    TextInputProps & RefAttributes<HTMLInputElement>
  >;
